import { EVENTS_URL } from 'api/UserEventsAPI';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import { EventInfo } from '../domain';
import { useUserKey } from './useUserKey';

type UseEventHistoryQueryOptions = {
  from: number;
  limit: number;
  filter: string;
  eventTypes: string[];
  sortBy: string;
  sortDirection: SORT_DIRECTIONS;
  userAgents: string[];
};

type UserEventsApiRequestPayload = {
  from: number;
  limit: number;
  filter: string;
  sort?: string;
  orderAscending?: boolean;
  userAgents?: string[];
  eventTypes?: string[];
};

type UserEventsApiResponse = {
  count: number;
  jsonEvents: EventInfo[];
};

export const useEventHistoryQuery = (
  {
    from,
    limit,
    filter,
    eventTypes,
    sortBy,
    sortDirection,
    userAgents,
  }: UseEventHistoryQueryOptions,
  refetchInterval?: number,
) => {
  const userId = useUserKey();
  return useRestQuery<UserEventsApiResponse, UserEventsApiRequestPayload>(
    `${EVENTS_URL}${userId}`,
    {
      from,
      limit,
      filter,
      sort: sortBy,
      orderAscending: sortDirection === SORT_DIRECTIONS.ASCENDING,
      userAgents,
      eventTypes,
    },
    refetchInterval ? { refetchInterval } : undefined,
  );
};
